"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeAgendaSettings = void 0;

var _DateHelper = require("./DateHelper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var normalizeAgendaSettings = function normalizeAgendaSettings(settings, event) {
  var defaultSettings = {
    filters: [],
    locations: [],
    dateFormat: 'ddd MMM DD',
    timeFormat: 'h:mm A'
  };
  return _objectSpread(_objectSpread(_objectSpread({}, defaultSettings), settings), {}, {
    startDate: settings && settings.startDate ? (0, _DateHelper.getUtcStartOfDay)(settings.startDate) : (0, _DateHelper.getUtcStartOfDay)(event['start-date'], event['time-zone-id']),
    endDate: settings && settings.endDate ? (0, _DateHelper.getUtcStartOfDay)(settings.endDate) : (0, _DateHelper.getUtcStartOfDay)(event['end-date'], event['time-zone-id'])
  });
};

exports.normalizeAgendaSettings = normalizeAgendaSettings;